<template>
    <v-navigation-drawer dark app clipped fixed disable-resize-watcher v-bind:value="value" v-on:input="$emit('input', $event)" style="width: 220px;">
        <v-layout class="fill-height" tag="v-list" column>
            <v-list>
                <template v-for="menu in menus">
                    <v-list-tile v-bind:key="menu.href" ripple class="drawerTile">
                        <v-list-tile-action>
                            <v-icon aria-hidden="true" color="#fff">{{menu.icon}}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile>
                            <router-link v-on:focus.native="$emit('focus-nav-drawer-link', $event)" :to="{ name: `${menu.href}` }">{{menu.text}}</router-link>
                        </v-list-tile>
                    </v-list-tile>
                </template>
            </v-list>
        </v-layout>
    </v-navigation-drawer>
</template>

<script>
    import Handbook from '@/mixins/HandbookAPI'

    export default {
        props: {
            value: {
                type: Boolean,
                default: false
            }
        },
        data() {
            var data = {
                //  Vue default icon reference:
                //  https://material.io/resources/icons/?style=baseline
                menus: [{
                    text: 'Home',
                    href: this.$store.state.ROUTE_HOME,
                    icon: 'home'
                },
                {
                    text: this.$store.state.STRING_PARLIAMENTARIANS,
                    href: this.$store.state.ROUTE_PARLIAMENTARIANS,
                    icon: 'person'
                },
                {
                    text: 'Prime Ministers',
                    href: this.$store.state.ROUTE_PRIME_MINISTERS,
                    icon: 'person'
                },
                {
                    text: 'Ministries',
                    href: this.$store.state.ROUTE_MINISTRIES,
                    icon: 'people'
                },
                {
                    text: 'Shadow Ministries',
                    href: this.$store.state.ROUTE_SHADOWMINISTRIES,
                    icon: 'people_outline'
                },
                {
                    text: 'Presidents',
                    href: this.$store.state.ROUTE_PRESIDENTS,
                    icon: 'person'
                },
                {
                    text: 'Speakers',
                    href: this.$store.state.ROUTE_SPEAKERS,
                    icon: 'person'
                },
                {
                    text: 'Electorates',
                    href: this.$store.state.ROUTE_ELECTORATES,
                    icon: 'home_work'
                },
                {
                    text: 'Elections and By-Elections',
                    href: this.$store.state.ROUTE_ELECTIONS,
                    icon: 'format_list_numbered'
                },     
                {
                    text: 'Committees',
                    href: this.$store.state.ROUTE_COMMITTEES,
                    icon: 'groups'
                },
                {
                    text: 'Referendums',
                    href: this.$store.state.ROUTE_REFERENDUMS,
                    icon: 'format_list_numbered'
                },       
                {
                    text: 'Royal Commissions',
                    href: this.$store.state.ROUTE_ROYAL_COMMISSIONS,
                    icon: 'gavel'
                },
                {
                    text: 'Ministerial Statements',
                    href: this.$store.state.ROUTE_MINISTERIAL_STATEMENTS,
                    icon: 'chat_bubble_outline'
                },                
                {
                    text: 'Heads of State',
                    href: this.$store.state.ROUTE_HEADS_OF_STATE,
                    icon: 'person'
                },
                {
                    text: 'Parliamentary Office Holders',
                    href: this.$store.state.ROUTE_STATUTORY_OFFICE_HOLDERS,
                    icon: 'person'
                },
                {
                    text: 'Facts, Figures and Timelines',
                    href: this.$store.state.ROUTE_STATISTICAL_INFORMATION,
                    icon: 'bar_chart'
                },
                {
                    text: this.$store.state.STRING_ADVANCED_SEARCH,
                    href: this.$store.state.ROUTE_ADVANCED_SEARCH,
                    icon: 'person_search'
                },
                ]
            }
            if (Handbook.Production) {
                data.menus = [{
                    text: 'Home',
                    href: this.$store.state.ROUTE_HOME,
                    icon: 'home'
                },
                {
                    text: this.$store.state.STRING_PARLIAMENTARIANS,
                    href: this.$store.state.ROUTE_PARLIAMENTARIANS,
                    icon: 'person'
                },
                {
                    text: 'Prime Ministers',
                    href: this.$store.state.ROUTE_PRIME_MINISTERS,
                    icon: 'person'
                },
                {
                    text: 'Ministries',
                    href: this.$store.state.ROUTE_MINISTRIES,
                    icon: 'people'
                },
                {
                    text: 'Shadow Ministries',
                    href: this.$store.state.ROUTE_SHADOWMINISTRIES,
                    icon: 'people_outline'
                },
                {
                    text: 'Presidents',
                    href: this.$store.state.ROUTE_PRESIDENTS,
                    icon: 'person'
                },
                {
                    text: 'Speakers',
                    href: this.$store.state.ROUTE_SPEAKERS,
                    icon: 'person'
                },
                {
                    text: 'Electorates',
                    href: this.$store.state.ROUTE_ELECTORATES,
                    icon: 'home_work'
                },
                 {
                    text: 'Elections and By-Elections',
                    href: this.$store.state.ROUTE_ELECTIONS,
                    icon: 'format_list_numbered'
                },
                {
                    text: 'Committees',
                    href: this.$store.state.ROUTE_COMMITTEES,
                    icon: 'groups'
                }, 
                {
                    text: 'Referendums',
                    href: this.$store.state.ROUTE_REFERENDUMS,
                    icon: 'format_list_numbered'
                },    
                {
                    text: 'Royal Commissions',
                    href: this.$store.state.ROUTE_ROYAL_COMMISSIONS,
                    icon: 'gavel'
                },
                {
                    text: 'Ministerial Statements',
                    href: this.$store.state.ROUTE_MINISTERIAL_STATEMENTS,
                    icon: 'chat_bubble_outline'
                },
                {
                    text: 'Heads of State',
                    href: this.$store.state.ROUTE_HEADS_OF_STATE,
                    icon: 'person'
                },
                {
                    text: 'Parliamentary Office Holders',
                    href: this.$store.state.ROUTE_STATUTORY_OFFICE_HOLDERS,
                    icon: 'person'
                },
                {
                    text: 'Facts, Figures and Timelines',
                    href: this.$store.state.ROUTE_STATISTICAL_INFORMATION,
                    icon: 'bar_chart'
                },
                {
                    text: this.$store.state.STRING_ADVANCED_SEARCH,
                    href: this.$store.state.ROUTE_ADVANCED_SEARCH,
                    icon: 'person_search'
                },
                ]
            }
            if (Handbook.Debug) {
                data.menus.push({
                    text: 'Diagnostics',
                    href: this.$store.state.ROUTE_DIAGNOSTICS,
                    icon: 'security'
                });
                data.menus.push({
                    text: 'Electorate Maps',
                    href: this.$store.state.ROUTE_ELECTORATEMAPS,
                    icon: 'map'
                });
            }

            return data;
        },
        methods: {
            location(location, p) {
                if (!p) {
                    this.$router.push(location)
                } else {
                    this.$router.push({
                        name: location,
                        params: {
                            pid: p
                        }
                    })
                }
            }
        }
    }
</script>
<style scoped>
    a {
        color: #fff;
        text-decoration: none;
    }

    .v-list__tile__action {
        min-width: 20px;
    }

    .drawerTile {
        transition: 0.5s;
    }

        .drawerTile:hover {
            background-color: #396596 !important;
        }

    #v-list {
        width: 200px;
    }
</style>
